import { BannerCard, Carousel } from '@design-system';
import React, { FC } from 'react';

import { VideoStoryblok } from '../../../types/generated-storyblok';
import { StoryblokVideo } from '../../../types/Vimeo';
import {
  TrackCarouselSlide,
  TrackMultiMediaClick,
} from '../../../utils/analytics';
import PageSection from '../../Layout/PageSection';
import { ArtistEventTile } from '../ArtistEventTile';
import { ArtistVideo } from '../ArtistVideo';

type BlokTypes = EventType | StoryblokVideo | LinkCardImageComponent;

interface ArtistExclusiveProps {
  analytics: Analytics;
  artistName: string;
  exclusive: Array<BlokTypes>;
  title: string;
}

export const ArtistExclusive: FC<ArtistExclusiveProps> = ({
  analytics,
  artistName,
  exclusive = [],
  title,
}) => {
  return (
    <PageSection fullWidth>
      <Carousel
        headline={title}
        items={exclusive.map((item) => (
          <>
            {item.component === 'Video' && (
              <ArtistVideo
                analytics={analytics}
                blok={item as VideoStoryblok}
                coverImageSize={{
                  sm: { ratio: '4/3', span: 12 },
                  md: { ratio: '4/3', span: 6 },
                  lg: { ratio: '4/3', span: 6 },
                }}
              />
            )}
            {item.component === 'event' && (
              <ArtistEventTile
                analytics={analytics}
                artistName={artistName}
                event={item}
              />
            )}
            {item.component === 'linkCardImage' && (
              <BannerCard
                as="a"
                aspectRatioClassName="aspect-[4/3]"
                description={item.subtitle}
                href={item.link.url}
                image={item.image}
                onClick={() => {
                  TrackMultiMediaClick({
                    ...analytics,
                    type: 'image',
                    title: item.title,
                  });
                }}
                title={item.title}
                variant="image"
              />
            )}
          </>
        ))}
        onSlide={(index: number) => {
          TrackCarouselSlide({
            ...analytics,
            title,
            position: index,
            carouselLength: exclusive.length,
          });
        }}
        perPage={2}
      />
    </PageSection>
  );
};
